$ = jQuery;

$('#marcas-content').find('a').on('click', function () {
  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Catálogo 0km',
    'eventAction': 'Clique - Explorar - Marcas - Card',
    'eventLabel': $(this).text().trim()
  });

  gtag('event', 'Catálogo 0km', {
    'eventAction': 'Clique - Explorar - Marcas - Card',
    'eventLabel': $(this).text().trim()
  });
});

$('#carrocerias-content').find('a').on('click', function () {
  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Catálogo 0km',
    'eventAction': 'Clique - Explorar - Carrocerias - Card',
    'eventLabel': $(this).text().trim()
  });

  gtag('event', 'Catálogo 0km', {
    'eventAction': 'Clique - Explorar - Carrocerias - Card',
    'eventLabel': $(this).text().trim()
  });
});

$('#estilosdevida-content').find('a').on('click', function () {
  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Catálogo 0km',
    'eventAction': 'Clique - Explorar - Estilos de Vida - Card',
    'eventLabel': $(this).text().trim()
  });

  gtag('event', 'Catálogo 0km', {
    'eventAction': 'Clique - Explorar - Estilos de Vida - Card',
    'eventLabel': $(this).text().trim()
  });
});

$('#marcas-tab, #carrocerias-tab, #estilosdevida-tab').on('click', function () {
  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Catálogo 0km',
    'eventAction': 'Clique - Explorar - Tab',
    'eventLabel': $(this).children('span').text().trim()
  });

  gtag('event', 'Catálogo 0km', {
    'eventAction': 'Clique - Explorar - Tab',
    'eventLabel': $(this).children('span').text().trim()
  });
});


